export const defaultStats = {
  VIDEO_VIEW_SECTION: {
    tag: 'VIDEO_VIEW_SECTION',
  },
  WEBINAR_ENTER: {
    tag: 'WEBINAR_ENTER',
  },
};
